export const filterNulls = <T>(arr: T[]) => arr.filter(q => q !== null) as NonNullable<T>[];
